import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TrinityContextType {
  selectedEntity: `0x${string}` | undefined;
  setSelectedEntity: (entity: `0x${string}` | undefined) => void;
}

const TrinityContext = createContext<TrinityContextType | undefined>(undefined);

export function TrinityProvider({ children }: { children: ReactNode }) {
  const [selectedEntity, setSelectedEntity] = useState<`0x${string}` | undefined>(undefined);

  return (
    <TrinityContext.Provider value={{ selectedEntity, setSelectedEntity }}>
      {children}
    </TrinityContext.Provider>
  );
}

export function useTrinityContext() {
  const context = useContext(TrinityContext);
  if (context === undefined) {
    throw new Error('useTrinityContext must be used within a TrinityProvider');
  }
  return context;
} 